module.exports = __webpack_public_path__ + "static/media/14.a3a13d5a.jpeg";